import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import contentSubmissionAnalysisUpdaters from '@/api/updaters/contentSubmissionAnalysis';

function useUpdateContentSubmissionAnalysis({
  contentSubmissionVersionId,
}: {
  contentSubmissionVersionId: string | undefined;
}) {
  return useMutation({
    mutationKey: ['contentSubmissionAnalysis', 'update'],
    mutationFn: ({
      id,
      analysisRating,
      analysisNote,
    }: {
      id: string;
      analysisRating?: number | null;
      analysisNote?: string | null;
    }) =>
      contentSubmissionAnalysisUpdaters.update(id, {
        analysisRating,
        analysisNote,
      }),
    onSuccess: (_, variables) => {
      if (contentSubmissionVersionId) {
        queryClient.invalidateQueries([
          'contentSubmissionVersion',
          contentSubmissionVersionId,
        ]);
      }
    },
  });
}

export default useUpdateContentSubmissionAnalysis;
